<template>
  <ODialog ref="dialog" :max-width="600">
    <v-card v-if="button != null">
      <ODialogBar
        :title="`Editar Botão: ${this.button.code}`"
        @close="dismiss()"
      >
        <v-spacer />
        <v-btn icon title="Copiar ações" @click="doCopy">
          <v-icon>mdi-content-copy</v-icon>
        </v-btn>
        <v-btn icon title="Colar ações" @click="doPaste">
          <v-icon>mdi-content-paste</v-icon>
        </v-btn>
      </ODialogBar>

      <v-card-text class="pa-3 children-pa-3">
        <div
          class="v-row"
          v-for="(action, aIndex) in button.actions"
          :key="aIndex"
        >
          <div class="h-row">
            <v-select label="Ação" v-model="action.code" :items="buttonOpts" />
            <v-spacer />

            <v-btn icon @click="removeAction(aIndex)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </div>
          <div class="v-row mx-10">
            <div
              v-for="(pType, pIndex) in paramTypes(action.code)"
              :key="pIndex"
            >
              <ODecHexInput
                v-if="pType == 'integer'"
                label="Valor numérico"
                format="hex"
                v-model="action.params[pIndex]"
              />

              <v-select
                v-if="pType == 'screenIndex'"
                label="Tela"
                v-model="action.params[pIndex]"
                :items="selectableScreens"
              />

              <v-select
                v-if="pType == 'variableName'"
                label="Variável"
                v-model="action.params[pIndex]"
                :items="screenVarOpts"
              />
            </div>
          </div>
        </div>

        <div class="h-row children-pa-3">
          <div v-if="button.actions.length < 1">
            Não existem ações.
          </div>
          <v-spacer />
          <div>
            <v-btn icon @click="addAction">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </div>
        </div>

        <v-sheet class="mono elevation-1 mx-4">Preview: 0x{{previewHex | hex}}</v-sheet>
      </v-card-text>

      <ODialogButtons class="pa-6" @cancel="dismiss" @apply="apply" />
    </v-card>
  </ODialog>
</template>

<script>
import { screenVarOpts, buttonOpts } from './screen-opts'
import { ScreenSet } from '@/models'

export default {
  components: {
    ODecHexInput: require('oderon-vue/cpts/ODecHexInput.vue').default
  },
  data() {
    return this.reset()
  },
  computed: {
    selectableScreens() {
      return this.allScreens.map((s, index) => {
        return {
          value: '0x' + index.toString(16),
          text: `${index.toString().padStart(2, '0')} - ${s.line0}`
        }
      })
    }
  },
  watch: {
    button: {
      deep: true,
      handler() { this.updatePreview() }
    }
  },
  methods: {
    reset() {
      return {
        button: null,
        allScreens: [],
        screenVarOpts,
        buttonOpts,
        previewHex: ''
      }
    },

    dismiss() {
      return this.$refs.dialog.$dismiss()
    },

    open(button, allScreens) {
      Object.assign(this, this.reset())
      this.allScreens = allScreens

      button = JSON.parse(JSON.stringify(button))
      if (button.actions == null) button.actions = []
      this.button = button

      return this.$refs.dialog.$open()
    },

    apply() {
      this.$refs.dialog.$apply(this.button)
    },

    addAction() {
      this.button.actions.push({ code: null, params: [] })
    },

    removeAction(index) {
      this.button.actions.splice(index, 1)
    },

    doCopy() {
      window.screenSetButtonClipboard = JSON.stringify(this.button.actions)
    },

    doPaste() {
      let s = window.screenSetButtonClipboard
      if (s) {
        s = JSON.parse(s)
        this.button.actions.push(...s)
      }
    },

    paramTypes(actionCode) {
      if (actionCode == null) return []
      let opt = buttonOpts.find(o => o.value == actionCode)
      if (opt && opt.paramTypes) return opt.paramTypes
      return []
    },

    async updatePreview() {
      this.previewHex = await ScreenSet.previewButton(this.button)
    }
  }
}
</script>

<style lang="sass">
.grid3
  display: grid
  grid-template-columns: 1fr 1fr 1fr

.grid2
  display: grid
  grid-template-columns: 1fr 1fr

.gap4
  gap: 16px
</style>
